import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJDUVList from './DJDUVList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJTMListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const { register, handleSubmit, watch, setError, formState } = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [DJDUVListData, setDJDUVListData] = useState([]);

    const EnableBtn = parseInt(watch('myViniedo'));

    useEffect(() => {
        // const getMyDJDUV = async () => {
        //     try {
        //         setLoader(true);
        //         const myDJDUVs = await DJDUVService.all({
        //             token,
        //             usuarioId: user.id,
        //             // serie: parseInt(dayjs(new Date()).format('YYYY')),
        //         });
        //         if (myDJDUVs) {
        //             setDJDUVListData(myDJDUVs.data);
        //             setTableData(buildTableData(myDJDUVs.data));
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //     }
        // };
        // if (user.tipo !== 3) getMyDJDUV();
    }, []);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJDUVs*/
    const buildTableData = (
        data = [
            {
                id: 1,
                viniedo: '',
                fecha: '',
                fecha_cierre: '',
                timbre: '',
                habilitada: '',
                total_kilos: '',
                cerrada: '',
            },
        ]
    ) => {
        return {
            title: 'Declaraciones de División/Unificación de Viñedo',
            headers: [
                'ID',
                'Viñedo',
                'Fecha',
                'Timbre',
                'Habilitada',
                'Kilos Totales',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data: data?.map((dj) => {
                return {
                    id: `${dj.serie}-P-${dj.numero}`,
                    viniedo: dj.viniedo,
                    fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                    timbre: dj.timbre ? 'PAGO' : 'NO PAGO',
                    habilitada: masters.HabilitationTypes?.find(
                        (ht) => ht.id === dj.habilitada
                    )?.nombre.replace('_', ' '),
                    kilosTotales: dj.total_Kilos,
                    cerrada: !dj.fecha_cierre ? 'NO' : dj.fecha_cierre,
                    icons: (
                        <div>
                            <Link
                                to={
                                    RoutesApp.Declaraciones.divUnifViniedo +
                                    dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                            <Link
                                to={
                                    RoutesApp.Declaraciones
                                        .nuevaDivUnifViniedo + dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={pencil}
                                    title="Editar"
                                    alt="Editar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    const newDJDUV = async (data) => {
        try {
            setLoader(true);

            // const newDJDUV = await DJDUVService.create({
            //     token,
            //     viniedoId: data.myViniedo,
            // });

            // if (newDJDUV) {
            //     Navigate(
            // RoutesApp.Declaraciones.nuevaModificacionViniedo +
            //             newDJDUV.data.cabecera.id
            //     );
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <DJDUVList
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                newDJDUV,
            }}
            states={{
                DJDUVListData,
                tableData,
                viniedos,
                settings,
                EnableBtn,
            }}
        />
    );
}

export default DJTMListContainer;
